import React from "react";

import {
  FELINE_LEFT_SHAPES,
  FELINE_RIGHT_SHAPES,
  renderShape,
} from "./utils";

const FelineDentalChart = ({ toothConditions }) => {
  return (
    <svg
      viewBox="-14 0 204 292"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <text
        x="-4"
        y="146"
        textAnchor="middle"
        dominantBaseline="central"
        fill="#64748b"
        fontSize="14"
        fontFamily="sans-serif"
        fontWeight="bold"
      >
        R
      </text>
      <text
        x="180"
        y="146"
        textAnchor="middle"
        dominantBaseline="central"
        fill="#64748b"
        fontSize="14"
        fontFamily="sans-serif"
        fontWeight="bold"
      >
        L
      </text>
      <g id="Feline">
        <g id="Feline-Right">
          {FELINE_RIGHT_SHAPES.map(({ type, id, ...props }) =>
            renderShape(type, id, props, toothConditions),
          )}
        </g>
        <g id="Feline-Left">
          {FELINE_LEFT_SHAPES.map(({ type, id, ...props }) =>
            renderShape(type, id, props, toothConditions),
          )}
        </g>
      </g>
    </svg>
  );
};

export default FelineDentalChart;
